<template>
  <div>
    <!-- {{ lessonIndex }}
    <pre>{{ lessonContent }}</pre> -->
    <!-- <pre>{{lessons}}</pre> -->
    <h3 class="course-heading">{{ lessons.lesson.name }}</h3>
    <div class="cstm-breadcrumb">
      <p class="bread-menus" @click="redirectBackToContent()">
        {{ lessonContent.name }}
      </p>
      <p class="bread-menus">{{ lessons.lesson.name }}</p>
    </div>
    <!-- description about lesson -->
    <div class="desc-container">
      <p v-if="summary">
        {{ lessons.lesson.description | limitTo(200) }}
        <!-- {{lessons.lesson.description.length}} -->
        <a class="cursor-pointer" @click="summary = false" >Read more</a>
      </p>
      <p v-else>
        {{ lessons.lesson.description }}
        <a class="cursor-pointer" @click="summary = true"  > Read less</a>
      </p>
    </div>
    <vs-tabs class="cstm-card">
      <vs-tab label="Content" icon-pack="feather" icon="icon-align-justify">
        <div>
          <vs-card v-if="lessons.lesson.lesson_content.content">
            <p v-html="lessons.lesson.lesson_content.content"></p>
          </vs-card>
        </div>
      </vs-tab>
     <!--  <vs-tab label="Q&A" icon-pack="feather" icon="icon-help-circle">
        <vs-card>
      <question-modal
      v-if="lessons.lesson.lesson_questions.length"
      :QuestionModal="lessons.lesson.lesson_questions"
      Modaltype="Question"
      :lessonId="lessons.lesson_id"
      :sectionType="2"

      ></question-modal>
        </vs-card>
      </vs-tab> -->
     <!--  <vs-tab label="Assignments" icon-pack="feather" icon="icon-file-text">
        <assignment-modal
       :lessonAssignment ="lessons.lesson.lesson_assignments"
       :sectionType="2"

        ></assignment-modal>
      </vs-tab> -->

        
         <vs-tab
          label="Homework"
          icon-pack="feather"
          icon="icon-file-text"
        >

        
          <assignment-modal
            :lessonAssignment="getAssignmentByType(lessons.lesson.lesson_assignments,2)"
          :sectionType="2"
        
          ></assignment-modal>
        </vs-tab>
 <vs-tab
          label="Exams"
          icon-pack="feather"
          icon="icon-file-text"
        >

        
          <assignment-modal
            :lessonAssignment="getAssignmentByType(lessons.lesson.lesson_assignments,4)"
          :sectionType="2"
        
          ></assignment-modal>
        </vs-tab>
         <vs-tab
          label="Reports"
          icon-pack="feather"
          icon="icon-file-text"
        >

        
          <assignment-modal
            :lessonAssignment="getAssignmentByType(lessons.lesson.lesson_assignments,3)"
          :sectionType="2"
         
          ></assignment-modal>
        </vs-tab>
      <vs-tab label="Files" icon-pack="feather" icon="icon-file">
        <div>
          <div class="flex flex-wrap -mx-2">
            <!-- {{lessons.lesson_files}} -->
            <div
              v-for="(eachFiles, index) in lessons.lesson.lesson_files"
              :key="index"
              class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-2"
            >
              <vs-card class="file-card">
                <div slot="header">
                  <img
                    class="w-full file-image"
                    :src="eachFiles.file.file_path"
                    alt=""
                  />
                </div>
                <h5 class="file-name">{{ eachFiles.file.file_name }}</h5>
                <p>{{ eachFiles.file.size }}</p>
                <!-- <a class="float-right" href="#"
                  ><feather-icon icon="DownloadIcon"
                /></a> -->
                                      <vs-button color="success" 
                                      class="float-right"
                                      type="flat" @click="downloadImage(eachFiles.file)" icon-pack="feather" icon="icon-download"></vs-button>

              </vs-card>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

        <vs-row vs-w="12">
          <vs-col type="flex" vs-w="4">
            <vs-button
              icon-pack="feather"
              icon="icon-chevron-left"
              @click="redirectBackToContent()"
              >Back To Course</vs-button
            >
          </vs-col>
          
          <!-- <vs-col type="flex" vs-w="4"
          v-if="!lessons.lesson.lesson_complete_count"
          >
            <vs-button color="success"
          type="border"
            @click="saveComplete(lessons.lesson.id)"
              >Mark As Complete</vs-button
            >
          </vs-col>

     <vs-col type="flex" vs-w="4" v-else>
        
        <vs-button color="success" icon-pack="feather" icon="icon-check"
          >Completed</vs-button
        >
      </vs-col> -->


          <!-- {{lessonContent.courseLessons.length}} -->
          <!-- {{lessonContent.courseLessons[0].lesson.lesson_topics.length}} -->
          <!-- {{lessonContent.courseLessons[lessonIndex].lesson.lesson_topics.length}} -->
          <vs-col type="flex" vs-w="4">
            <vs-button
              v-if="
                lessonContent.courseLessons[lessonIndex].lesson.lesson_topics
                  .length
              "
              icon-pack="feather"
              icon="icon-chevron-right"
              icon-after
              @click="redirectNextTopic()"
            >
              {{
                lessonContent.courseLessons[lessonIndex].lesson.lesson_topics[0]
                  .topic.name
              }}
            </vs-button>
              <div v-else>
            <vs-button
            v-if="this.lessonContent.courseLessons.length != lessonIndex + 1"
              icon-pack="feather"
              icon="icon-chevron-right"
              icon-after
              @click="redirectNextLesson()"
            >
              {{ lessonContent.courseLessons[lessonIndex].lesson.name }}
            </vs-button>
            '</div>
          </vs-col>
        </vs-row>
  </div>
</template>

<script>
import QuestionModal from './QuestionModal.vue'
import AssignmentModal from './AssignmentModal.vue'
// import {MarkCompleteMixin} from '../mixins/MarkCompleteMixin'
import axios from 'axios'


export default {
  components:{
    QuestionModal,
    AssignmentModal
  },
  // mixins:[MarkCompleteMixin],

  props: {
    lessonContent: {
      type: Object,
      required: true,
      default: () => {}
    },
    lessonIndex: {
      type:Number,
      default:null
    }
  },
  created () {
    this.lessons = this.lessonContent.courseLessons[this.lessonIndex]

  },
  // mounted () {
  // },
  methods: {
    getAssignmentByType (assignment, type) {
      return assignment.filter(ele => {
        console.log(ele)
        if (ele.assignment) {
          return ele.assignment.assignment_type_id === type
        }
      })
    },
    redirectBackToContent () {
      
      this.$emit('backToContent')
    },
    redirectNextLesson () {
      
      this.$emit('backToLesson', 1)
    },
    redirectNextTopic () {
      
      this.$emit('backToTopic', this.lessonIndex)
    },
    saveComplete (lesson_id) {
      
      const payload = {
        lesson_id,
        type:2
      }

      this.markComplete(payload)

      const isMarkDone = this.markComplete(payload)
      if (isMarkDone) {
        
        this.lessons.lesson.lesson_complete_count = 1
      }
    },
    downloadImage (item) {
      
      axios({
        url: `https://cors-anywhere.herokuapp.com/${  item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      }).catch(error => {
        
      }).finally(() => {
        

      })

    }
  },
  data () {
    return {
      lessons: '',
      isCollapse:false,
      summary:false
    }
  },
  filters: {
    limitTo (value) {
      if (!value) return ''
      return `${value.substring(0, 200)}...`
    }
  },
  watch: {
    lessonIndex () {
      this.lessons = this.lessonContent.courseLessons[this.lessonIndex]
    }
  }
}
</script>